import { createUIDefinition } from '../default-task-definition'
import * as taskName from './task-name'
import * as processUI from '../../process-ui'


export default createUIDefinition({
    taskName: taskName.SHIP_SET,
    widgetList: [
        {
            component: processUI.TRAY_SIZE_WIDGET,
            readOnly: false,
        },
        {
            component: processUI.IMPRINT_SCAN_STATUS_WIDGET,
            readOnly: false,
        },
        {
            component: processUI.SHIPMENT_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
    ],
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/ship-set.js